import { format } from "@/utils";
import { useEffect, useState } from "react";

const getRefreshInterval = (dateTime: string) => {
  const now = Date.now();
  const date = new Date(dateTime).getTime();
  const diff = (now - date) / 1000; // seconds

  if (diff < 60) return 1000; // update every second
  if (diff < 3600) return 60000; // update every minute
  if (diff < 86400) return 3600000; // update every hour
  return null; // no update after 24 hours
};

type TimeAgoProps = { dateTime: string };

const TimeAgo = (props: TimeAgoProps) => {
  const { dateTime } = props;

  const [timeAgo, setTimeAgo] = useState(() => format.timeAgo(dateTime));

  useEffect(() => {
    setTimeAgo(format.timeAgo(dateTime));
    const interval = getRefreshInterval(dateTime);
    if (!interval) return; // no timer needed after 24 hours

    const timer = setInterval(() => {
      setTimeAgo(format.timeAgo(dateTime));
    }, interval);

    return () => {
      clearInterval(timer);
    };
  }, [dateTime, timeAgo]);

  return timeAgo;
};

export default TimeAgo;
